import axios, { InternalAxiosRequestConfig } from 'axios';
import { getRecaptchaToken } from '../security/recaptcha';

declare module 'axios' {
  export interface AxiosRequestConfig {
    recaptchaAction?: string;
    skipRecaptcha?: boolean;
  }
}

function getExistingRecaptchaHeader(
  config: InternalAxiosRequestConfig
): string | undefined {
  if (typeof config.headers.get === 'function') {
    const headerValue = config.headers.get('Recaptcha-Token');
    return typeof headerValue === 'string' ? headerValue : undefined;
  }

  return undefined;
}

export const Api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
});

Api.interceptors.request.use(async (config: InternalAxiosRequestConfig) => {
  if (config.skipRecaptcha) {
    return config;
  }

  const existingRecaptchaHeader = getExistingRecaptchaHeader(config);
  if (!existingRecaptchaHeader) {
    const recaptchaToken = await getRecaptchaToken(
      config.recaptchaAction || 'api_request'
    );
    config.headers.set('Recaptcha-Token', recaptchaToken);
  }

  return config;
});
